<template>
    <div>
        <div :class="{'show': showBroadcastTargetToggle }" class="modal fade">
            <div class="modal-dialog modal-lg">
                <div class="modal-content modal-content-lg">
                    <div class="modal-header border-bottom">
                        <h5 class="modal-title h4 fw-500 pt-1">{{$t('salon_report.broadcast.header_broadcast_target')}}</h5>
                        <button type="button" class="close" @click="showBroadcastTargetToggle = false">
                            <span aria-hidden="true"><i class="fal fa-times"></i></span>
                        </button>
                    </div>
                    <div class="modal-body modal-body-lg">
                        <input type="hidden" v-model="broadcastTargetID"/>
                        <div class="row pt-5">
                            <div class="col-sm-12 col-md-5 border-right p-3 text-center">
                                <h6 class="text-secondary text-left d-block fw-300">{{$t('subMenu.my_salon_broadcast') + $t('table.header.image')}}:</h6>
                                <img class="broadcast-image img-fluid" :src="getImage(broadcastTargetImage)"/>
                            </div>
                            <div class="col-sm-12 col-md-7 p-3">
                                <div v-if="isBroadcastTargetSpinnerShow" class="d-flex justify-content-center mt-3 mb-3">
                                    <b-spinner label="Loading..."></b-spinner>
                                    </div>
                                <div class="panel-tag mt-3" v-if="!isBroadcastTargetSpinnerShow && broadcastTargetItems.length == 0">
                                    {{$t('table.no_records')}}
                                </div>
                                <div class="table-lg" v-if="!isBroadcastTargetSpinnerShow && broadcastTargetItems.length != 0">
                                    <h6 class="text-secondary fw-300">{{$t('salon_report.broadcast.header_broadcast_target')}}:</h6>
                                    <b-table small striped hover bordered :fields="fields" :items="broadcastTargetItems" responsive>
                                        <template #cell(index)="data">
                                            {{ data.index + 1 }}
                                        </template>
                                        <template #cell(action)="data">
                                            <a class="link d-block text-primary" title="Delete Broadcast Target" @click="showModal(data.item.mcastID, data.item.memberDisplayName)">
                                                <i class="fal fa-trash"></i>
                                            </a>
                                        </template>
                                    </b-table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <deleteModal ref="deleteModal" @performConfirmAction="deleteBroadcastTarget"></deleteModal>
    </div>
</template>
<script>
import DeleteModal from './../../Delete_Modal'
import {handleSessionExpired} from './../../../../assets/js/dashboard/dashboard'
export default {
    name: "broadcastTarget",
    components: {
        DeleteModal
    },
    props:{
        selectedOutlet: {type: Object}
    },
    data(){
        return{
            isBroadcastTargetSpinnerShow: false,
            showBroadcastTargetToggle: false,
            deleteToggleModal: false,
            broadcastTargetItems: [],
            broadcastTargetImage: "", broadcastTargetID: 0, broadcastTargetMember: "",
            mcastID: 0
        }
    },
    computed:{
        fields(){
            return[
                {key: "index", label: "#", thClass: 'thead-themed align-middle'},
                {key: "memberDisplayName", label: this.$i18n.t('table.header.name'), thClass: 'thead-themed align-middle', sortable: true},
                {key: "mobile", label: this.$i18n.t('table.header.contact'), thClass: 'thead-themed align-middle'},
                {key: "action", label: "", thClass: 'thead-themed text-center', tdClass: 'text-center'},
            ]
        }
    },
    methods:{
        closeModal(isError){
            if(!isError){
                this.$refs.deleteModal.toggleModal = false
                this.getBroadcastTarget(this.broadcastTargetID, this.broadcastTargetImage)
            }
            this.$parent.$parent.isModalShow = false
        },
        getImage(img){
            return img;
        },
        getBroadcastTarget(bcastID, image){
            let $vm = this;
            this.broadcastTargetID = bcastID;
            this.broadcastTargetImage = image;
            this.broadcastTargetItems = []
            this.isBroadcastTargetSpinnerShow = true;

            const url = this.$api.BROADCAST + "/" + bcastID + this.$api.BROADCAST_TARGET;
            $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: this.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                $vm.broadcastTargetItems = response.data.result;
                $vm.isBroadcastTargetSpinnerShow = false;
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            this.showBroadcastTargetToggle = true;
        },
        showModal(mcastID, name){
            this.mcastID = mcastID 
            this.broadcastTargetMember = name;

            var title = this.$i18n.t('header.delete', {'item': this.$i18n.t('salon_report.broadcast.header_broadcast_target')})
            var message = this.$i18n.t('message.confirmation.question', {'action': this.$i18n.t('message.confirmation.action.delete'), 'item': name})
            this.$refs.deleteModal.showModal(title, message)
        },
        deleteBroadcastTarget(){
            let $vm = this;
            const url =  $vm.$api.BROADCAST + "/" + $vm.broadcastTargetID + $vm.$api.BROADCAST_TARGET + "/" + $vm.mcastID + $vm.$api.DELETE;
            
            $vm.$axios({
                method: 'post', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then((response) => {
                if(response.status == 200){
                    $vm.deleteToggleModal = false;
                    var message = $vm.$i18n.t('subMenu.my_salon_member') +  $vm.$i18n.t('message.success.success', {'action': $vm.$i18n.t('message.success.action.delete')})
                    $vm.$parent.$parent.setModal($vm, false, true, message)
                }
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
        },
    }
}
</script>
<style scoped>
.show{
    display: block;
}
.broadcast-image{
    width: 20em;
    height: 20em;
    border: 2px solid #f3f3f3;
    border-radius: 20px;
}
.modal-body-lg{
    min-height: 65vh;
    max-height: 85vh;
    overflow-y: auto;
}
.table-lg{
    max-height: 55vh;
    overflow-y: auto;
    overflow-x: hidden;
}
</style>